import {
  Dialog as HeadlessDialog,
  DialogPanel as HeadlessDialogPanel,
  Transition,
  TransitionChild,
} from '@headlessui/react'
import classNames from 'classnames'
import { Fragment, RefObject } from 'react'

export interface DialogProps {
  isOpen: boolean
  onClose: () => void
  initialFocus?: RefObject<HTMLElement | null>
  children?: React.ReactNode
  size?: 'sm' | 'md' | 'xl' | '3xl' | '6xl'
}

const sizeClasses = {
  sm: 'sm:max-w-sm',
  md: 'sm:max-w-md',
  lg: 'sm:max-w-lg',
  xl: 'sm:max-w-xl',
  '3xl': 'sm:max-w-3xl',
  '6xl': 'sm:max-w-6xl',
}
export const Dialog = ({
  isOpen,
  onClose,
  children,
  initialFocus,
  size = 'sm',
}: DialogProps) => {
  return (
    <Transition show={isOpen} as={Fragment}>
      <HeadlessDialog
        as='div'
        className='relative z-40'
        onClose={onClose}
        initialFocus={initialFocus}
      >
        <TransitionChild
          as={Fragment}
          enter='ease-out duration-300'
          enterFrom='opacity-0'
          enterTo='opacity-100'
          leave='ease-in duration-200'
          leaveFrom='opacity-100'
          leaveTo='opacity-0'
        >
          <div className='fixed inset-0 bg-[#6B7280]/75 backdrop-blur-[2px] transition-opacity' />
        </TransitionChild>

        <div className='fixed inset-0 z-10 w-screen overflow-y-auto'>
          <div className='flex min-h-full items-end justify-center px-1 pt-4 text-center sm:items-center sm:p-0'>
            <TransitionChild
              as={Fragment}
              enter='ease-out duration-300'
              enterFrom='opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95'
              enterTo='opacity-100 translate-y-0 sm:scale-100'
              leave='ease-in duration-200'
              leaveFrom='opacity-100 translate-y-0 sm:scale-100'
              leaveTo='opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95'
            >
              <HeadlessDialogPanel
                className={classNames(
                  `relative w-full transform rounded-t-lg rounded-r-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-6 sm:rounded-lg sm:p-6`,
                  sizeClasses[size],
                )}
              >
                {children}
              </HeadlessDialogPanel>
            </TransitionChild>
          </div>
        </div>
      </HeadlessDialog>
    </Transition>
  )
}
